import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { BasicError, err } from "@nju/result";
import { ACCESS_TOKEN_SALES_KEY_NAME } from "@nju/scope";
import { decodeToken } from "../useDecodedToken";
import { IParams, IVerifyAddressResult } from "./types";
import { errorResponse, serverResponse } from "./validators";

const knownErrorCodes = new Set([
  "50122",
  "50124",
  "50125",
  "50126",
  "50130",
  "50149",
  "50131",
  "50150",
  "50182",
  "50190",
]);

export async function verifyAddress({
  cityId,
  cityName,
  streetId,
  streetName,
  houseNumber,
  apartmentNumber,
  variant,
}: IParams): Promise<IVerifyAddressResult> {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_SALES_KEY_NAME);
  const decodedToken = decodeToken(accessToken);

  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/installations/checks?limited=true`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      json: {
        municipality: cityName,
        municipalityId: cityId,
        street: streetName,
        streetId,
        streetNumber: houseNumber,
        apartmentNumber,
        ...(variant === "sales" &&
          decodedToken?.preferred_username && {
            "x-agent-login": decodedToken.preferred_username,
          }),
      },
      validator: serverResponse,
    },
  );

  if (result.isError) {
    const errorInfo = errorResponse.safeParse(result.err.extra?.json);

    if (errorInfo.success && errorInfo.data.code === "50237") {
      return err(
        new BasicError({
          message: "Missing apartment number",
          code: "MISSING_APARTMENT_NUMBER",
        }),
      );
    }

    if (
      !errorInfo.success ||
      !knownErrorCodes.has(errorInfo.data.code.toString())
    ) {
      Bugsnag.notify(result.err);
    }

    return result;
  }

  return result;
}
